// theme/customAntdTheme.ts

export const getCustomAntdTheme = () => {
  const getVar = (name: string) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  return {
    token: {
      colorPrimary: getVar("--color-primary") || "#eb3932",
      colorText: getVar("--color-text") || "#ffffff",
      colorBgBase: getVar("--color-bg") || "#111827",
      colorSuccess: getVar("--color-success") || "#058a29",
      colorError: getVar("--color-error") || "#d70000",
      fontFamily: "poppins",
    },
    components: {
      Select: {
        // Optional: Customize Select specifically
        selectorBg: getVar("--color-primary") || "#eb3932",
        colorBgContainer: getVar("--color-bgCard") || "#030712",
        // colorBorder: getVar("--color-primary") || "#eb3932",
      },
      Button: {
        colorPrimary: getVar("--color-primary") || "#eb3932",
      },
    },
  };
};
